import styled, { css } from 'styled-components';
import Flag from 'components/Flag';
import Tooltip from 'components/Tooltip';
import { fadeIn } from 'style';
import { th } from 'style/theme';
import TextInput from '../TextInput';

export const Wrapper = styled.div`
  display: flex;
  position: relative;
  justify-content: space-between;
`;

export const InputContainer = styled.div`
  position: relative;
  display: flex;
  gap: 8px;
  width: 100%;

  > :first-child {
    flex: initial;
  }
`;

export const CountryCodeInput = styled(TextInput)`
  width: 130px;
  transition: padding-left 200ms;

  ${({ $isFlagVisible }) =>
    $isFlagVisible &&
    css`
      padding-left: 40px;
    `}
`;

export const CountryFlag = styled(Flag)`
  display: ${(props) => (props.isFlagVisible ? 'block' : 'none')};
  position: absolute;
  width: 18px;
  top: 32px;
  left: 13px;
  animation: ${fadeIn} 0.4s;
  animation-delay: 0.15s;
  animation-fill-mode: both;
`;

export const Error = styled.span`
  margin-left: 5px;
  color: ${th('colors.red')};
  font-weight: 700;
  font-size: 14px;
`;

export const StyledTooltip = styled(Tooltip)`
  margin-left: 8px;
`;
